import { useAppContext } from 'src/components/app-context';
import matchRoute from 'src/routes/match-route';
import { useLocation } from 'react-router-dom';
import { routeConfig } from 'src/routes/config';
import { useContext } from 'react';
import { ExperimentContext } from 'src/components/experiment';

export function useMatchedRoute() {
  const context = useAppContext();
  const { market } = context;
  const location = useLocation();
  const experiments = useContext(ExperimentContext);

  return matchRoute({
    useClassicUrls: market.useClassicUrls,
    useHashForProductTabs: market.useHashForProductTabs,
    routeConfig,
    localizedRoutes: market.routes,
    location,
    marketCode: market.code,
    experiments: experiments.selectedVariants,
  });
}
